module.exports = __webpack_public_path__ + "media/images/selectionBet__flagBg-4d1024f34ea123fc16cd769fc82f75b4.jpg";